<template>
  <div class="flex flex-col w-screen h-screen dispatch-map">
    <div class="relative flex-grow bg-gray-800">
      <router-link :to="{ name: 'DispatchLoadOrders' }" class="absolute top-0 left-0 z-10 inline-flex items-center justify-center w-8 h-8 m-2 text-lg leading-none text-gray-500 transition duration-150 bg-transparent rounded hover:bg-white hover:no-underline">
        &larr;
      </router-link>

      <mgl-map
        class="w-full h-full"
        ref="map"
        :access-token="accessToken"
        :map-style="mapStyle"
        :zoom="10"
        @load="mapLoaded">
          <template v-for="route in routes">
            <mgl-marker :coordinates="[route.vehicle.longitude, route.vehicle.latitude]" :key="route.vehicle.id">
              <div slot="marker">
                <div class="flex items-center justify-center w-5 h-5 bg-opacity-25 rounded-full" :class="route.color">
                  <div class="w-3 h-3 rounded-full" :class="route.color"></div>
                </div>
              </div>
            </mgl-marker>
          </template>
      </mgl-map>

      <div class="absolute bottom-0 left-0 z-10 flex justify-between w-full p-2 bg-white border-t">

        <div class="space-x-2">
          <button class="btn btn-secondary">
            <fa :icon="['far', 'repeat']" class="mr-2" />
            Reoptimise
          </button>
          <button class="btn btn-primary">
            Save Routes &rarr;
          </button>
        </div>
      </div>
    </div>
    <div class="relative flex-grow w-screen overflow-y-auto bg-white border-t border-b divide-y shadow max-h-64">
      <div class="sticky top-0 flex text-xs font-bold tracking-wider text-gray-500 uppercase bg-gray-200">
        <div class="px-3 py-1 w-60">
          Driver
        </div>
        <div class="w-40 py-1" v-for="i in 7">
          {{ i + 9 }}:00
        </div>
      </div>
      <div>
        <div v-for="route in routes" :key="route.id" class="flex odd:bg-white even:bg-gray-100">
          <div class="px-3 py-2 text-xs leading-tight border-r w-60">
            <div class="font-medium truncate">{{ route.vehicle.objectname }}</div>
            <div class="text-gray-500">{{ route.vehicle.objectno }}</div>
          </div>
          <div class="relative flex">
            <div class="w-40 border-r" v-for="i in 6"></div>
            <div class="absolute flex items-center p-3 transform translate-x-4 -translate-y-1/2 top-1/2" :style="{
              width: `${route.total_time*2.75}px`
            }">
              <div class="absolute left-0 w-5 h-5 rounded-full" :class="route.color"></div>
              <div class="absolute left-0 w-full h-1" :class="route.color"></div>
              <div 
              v-for="(order, index) in route.orders" 
              :key="order.id" 
              class="absolute grid h-5 text-xs font-bold text-white rounded-full min-w-5 place-items-center" 
              :class="route.color"
              :style="{ 
                transform: `translateX(${order.arrival*2.75}px)`, 
                width: `${(order.duration)*2.75}px` 
              }">
                {{ index + 1 }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import mapboxgl from 'mapbox-gl'
import { MglMap, MglMarker, MglPopup } from 'vue-mapbox'

export default {
  name: 'DispatchPlanRoutes',

  components: {
    MglMap,
    MglMarker,
    MglPopup
  },

  data () {
    return {
      accessToken: 'pk.eyJ1IjoiZmxlZXRiZWFjb24iLCJhIjoiY2puZXczdHhmMHFqeDNrbGZ3dGNmbGU2cCJ9.dZ0JMOD5222pAk-pR6wzYQ',
      mapStyle: 'mapbox://styles/fleetbeacon/ckcw7i47m15m71imu9z9329lr',
      routes: [
        {
          total_time: 360,
          start_time: 5,
          color: 'bg-blue-500',
          vehicle: {
            objectname: 'Gregory',
            objectno: 'Ford Transit F8WERGP',
            latitude: -26.0076,
            longitude: 28.0567
          },
          orders: [
            { duration: 10, arrival: 18 },
            { duration: 10, arrival: 35 },
            { duration: 10, arrival: 82 },
            { duration: 10, arrival: 100 },
            { duration: 10, arrival: 156 },
            { duration: 10, arrival: 201 },
            { duration: 10, arrival: 350 },
          ]
        },
        {
          total_time: 300,
          start_time: 5,
          color: 'bg-red-500',
          vehicle: {
            objectname: 'Charlene',
            objectno: 'ISUZU D-MAX Y5LJMGP',
            latitude: -26.1076,
            longitude: 27.8967
          },
          orders: [
            { duration: 10, arrival: 20 },
            { duration: 10, arrival: 35 },
            { duration: 10, arrival: 48 },
            { duration: 10, arrival: 60 },
            { duration: 10, arrival: 79 },
            { duration: 10, arrival: 95 },
            { duration: 10, arrival: 164 },
            { duration: 10, arrival: 188 },
            { duration: 10, arrival: 290 },
          ]
        },
        {
          total_time: 325,
          start_time: 5,
          color: 'bg-yellow-500',
          vehicle: {
            objectname: 'Felix',
            objectno: 'ISUZU KB2 472YYGP',
            latitude: -26.0026,
            longitude: 28.1567
          },
          orders: [
            { duration: 10, arrival: 44 },
            { duration: 10, arrival: 55 },
            { duration: 10, arrival: 76 },
            { duration: 10, arrival: 105 },
            { duration: 10, arrival: 115 },
            { duration: 10, arrival: 138 },
            { duration: 10, arrival: 149 },
            { duration: 10, arrival: 236 },
            { duration: 10, arrival: 315 },
          ]
        },
        {
          total_time: 355,
          start_time: 5,
          color: 'bg-green-500',
          vehicle: {
            objectname: 'Ayla',
            objectno: 'VW Caddy 292XFGP',
            latitude: -26.1555,
            longitude: 28.2079
          },
          orders: [
            { duration: 10, arrival: 6 },
            { duration: 10, arrival: 52 },
            { duration: 10, arrival: 82 },
            { duration: 10, arrival: 125 },
            { duration: 10, arrival: 156 },
            { duration: 10, arrival: 201 },
            { duration: 10, arrival: 201 },
            { duration: 10, arrival: 345 },
          ]
        },
        {
          total_time: 328,
          start_time: 5,
          color: 'bg-purple-500',
          vehicle: {
            objectname: 'Lex',
            objectno: 'ISUZU KB 89WZGP',
            latitude: -26.2576,
            longitude: 28.0167
          },
          orders: [
            { duration: 10, arrival: 48 },
            { duration: 10, arrival: 77 },
            { duration: 10, arrival: 105 },
            { duration: 10, arrival: 175 },
            { duration: 10, arrival: 229 },
            { duration: 10, arrival: 262 },
            { duration: 10, arrival: 318 },
          ]
        }
      ]
    }
  },

  methods: {
    mapLoaded () {
      this.fitBounds()
    },

    fitBounds () {
      let bounds = new mapboxgl.LngLatBounds()

      this.routes.forEach(route => {
        bounds.extend([Number(route.vehicle.longitude), Number(route.vehicle.latitude)])
      })

      this.$refs.map.map.fitBounds(bounds, {
        padding: {
          top: 128,
          left: 128,
          bottom: 128,
          right: 128
        }
      })
    }
  }
}
</script>

<style lang="postcss">
.dispatch-map {
  .mapboxgl-popup-content {
    @apply px-2 shadow-none py-0 font-medium text-xs bg-gray-700 text-white;
  }

  .mapboxgl-popup-tip {
    @apply border-4;
  }

  .mapboxgl-popup-anchor-bottom,
  .mapboxgl-popup-anchor-bottom-left,
  .mapboxgl-popup-anchor-bottom-right, {
    .mapboxgl-popup-tip {
      border-top-color:theme('colors.gray.700');
    }
  }

  .mapboxgl-popup-anchor-top,
  .mapboxgl-popup-anchor-top-left,
  .mapboxgl-popup-anchor-top-right {
    .mapboxgl-popup-tip {
      border-bottom-color:theme('colors.gray.700');
    }
  }

  .mapboxgl-popup-anchor-left .mapboxgl-popup-tip {
    border-right-color:theme('colors.gray.700');
  }

  .mapboxgl-popup-anchor-right .mapboxgl-popup-tip {
    border-left-color:theme('colors.gray.700');
  }
}
</style>